import { Box, Stack, alpha, styled } from '@mui/material';

export const CvVideoStatuBarStyled = styled(Box)(({ theme }) => ({
  position: 'absolute',
  background: alpha(theme.palette.white.main, 0.24),
  width: '98%',
  left: '50%',
  top: 45,
  color: theme.palette.dark.dark_2,
  transform: 'translateX(-50%)',
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  border: '1px solid rgba(255, 255, 255, 0.35)',
  zIndex: 2,
}));

export const CvVideoOptionStyled = styled(Stack)(({ theme }) => ({
  background: theme.palette.dark.dark_6,
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
}));
export const CvVideoInfoStyled = styled(Stack)(({ theme }) => ({
  width: 208,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));
